/*Recurso: ptCatalogs - Servicio de lectura del API: Verifica la autenticación del usuario obteniendo clave y contraseña
  Tareas:
    GetAllEvidence    //Catálogo de Evidencias    //*RP
    GetAllCycles      //Catálogo de Ciclos        //*RP 
    GetAllFeatures
*/

import axios from "axios";
//import {IGetAllOrigin} from "../../interfaces/catalogs.modelo";
//import {IGetAllProcessByFrequency} from "../../interfaces/catalogs.modelo";

const API_URL = process.env.REACT_APP_API_URL + 'PtCatalogs/';

  //se genera una función por cada tarea del recurso api
    
    const cargaGetAllEvidence= async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllEvidence',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllEvidence', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllCycles = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllCycles/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllCycles/es', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllFeatures = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllFeatures',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllFeatures', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const ptCatalogsService = {
        cargaGetAllEvidence: cargaGetAllEvidence,
        cargaGetAllCycles: cargaGetAllCycles,
        cargaGetAllFeatures: cargaGetAllFeatures
    };

export default ptCatalogsService;
